import { mdiCalendarClockOutline, mdiCheckCircle, mdiCogOutline, mdiFeather } from '@mdi/js'
import Icon from '@mdi/react'
import { PresetCard } from 'components/PresetCard'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { currentUserSelector, trainingVideosSelector, trialTasksRecordSelector } from 'services/users/selectors'
import styles from './GettingStarted.pcss'

const css = require('styles/variables')

export type GetStartedTask = {
  code: string,
  name: string,
  description: string,
  action: string,
  completed: boolean,
  actionUrl: string,
  imageUrl: string,
  helpUrl?: string
}

interface GetStartedLink {
  id: string,
  title: string,
  subtitle: string,
  url: string,
  icon: React.ReactNode
  completed?: boolean
}

export const getStartedLinks: Array<GetStartedLink> = [
  {
    id: 'activate_social_profile',
    title: 'Connect your socials',
    subtitle: 'Connect at least one social network',
    url: '/settings/social-networks',
    icon: <Icon path={mdiCogOutline} size="34px" />
  }, {
    id: 'setup_plan',
    title: 'Setup your posting plan',
    subtitle: 'Add posting times to your plans',
    url: '/plans',
    icon: <Icon path={mdiCalendarClockOutline} size="34px" />
  }, {
    id: 'create_a_post',
    title: 'Create your first posts',
    subtitle: 'Schedule at least one post',
    url: '/composer',
    icon: <Icon path={mdiFeather} size="34px" />
  }
]

export function GettingStarted() {
  const user = useSelector(currentUserSelector)
  const sections = useSelector(trainingVideosSelector)
  const tasks = useSelector(trialTasksRecordSelector)
  const navigate = useNavigate()
  const [links, setLinks] = useState(getStartedLinks)

  useEffect(() => {
    const getStartedSection = sections.find(section => section.slug === 'getting-started')
    if (getStartedSection) {
      const updatedLinks = getStartedLinks.map(link => {
        const video = getStartedSection.videos?.find(vid => vid.taskCode === link.id)
        if (video) {
          const task = video.taskCode ? tasks[video.taskCode] : null
          return {
            ...link,
            completed: task ? task.completed : false
          }
        }
        return link
      })
      setLinks(updatedLinks)
    }
  }, [sections, tasks])

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        {`Howdy ${user?.name || ''} 👋 ... Let’s get your Post Planner set up!`}
      </h3>
      <div className={styles.grid}>
        {links.map((link) => (
          <PresetCard
            key={link.url}
            title={link.title}
            subtitle={link.subtitle}
            onClick={() => {
              navigate(link.url)
            }}
            icon={link.completed ? <Icon path={mdiCheckCircle} size="36px" color={css['--pp-green']} /> : link.icon}
            iconColor={css['--pp-green']}
            className={styles.card}
          />
        ))}
      </div>
    </div>
  )
}
